import { useState, useRef } from 'react';
import { Switch, Modal, Input, Select, notification, Radio, Space, DatePicker } from 'antd';
import XTable from 'components/XTable';
import {
    getCheckInRecordListApi,
    updateCheckInRecord,
    fastCheckInApi,
    getDownloadCheckApi,
} from 'api/checkInRecord';
import { getFilterText, downFile } from 'utils';
import { nursingAreas } from 'enumeration/nursingAreas';
import { checkIn } from 'enumeration/checkIn';
import { sexTypes } from 'enumeration/sexTypes';
import { identityType } from 'enumeration/identityType';
import moment from 'moment';
import XForm from 'components/XForm';
const { Option } = Select;
const formTailLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};
const CheckInRecord = () => {
    const xTableRef = useRef();
    const [editVisible, seteditVisible] = useState(false);
    const [editFastVisible, seteditFastVisible] = useState(false);
    const [editFastLoading, seteditFastLoading] = useState(false);
    const [editLoading, seteditLoading] = useState(false);
    const xFormRef = useRef();
    const xFastFormRef = useRef();
    const [id, setid] = useState('');

    const columns = [
        {
            title: '姓名',
            dataIndex: 'name',
        },
        {
            title: '身份证号',
            dataIndex: 'idNo',
        },
        {
            title: '年龄',
            dataIndex: 'age',
        },
        {
            title: '性别',
            dataIndex: 'sex',
            render: val => getFilterText(sexTypes, val),
        },
        {
            title: '入住区域',
            dataIndex: 'nursingArea',
            render: val => getFilterText(nursingAreas, val),
        },
        {
            title: '身份类型',
            dataIndex: 'identityType',
            render: val => getFilterText(identityType, val),
        },
        {
            title: '录入时间',
            dataIndex: 'createAt',
            render: val => (val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '-'),
        },
        {
            title: '入住状态',
            dataIndex: 'status',
            render: val => (val ? '在住' : '已出院'),
        },
        {
            title: '操作',
            dataIndex: '',
            render: (val, rowData) => {
                return (
                    <span className="actionText" onClick={() => editModalShow(rowData)}>
                        变更
                    </span>
                );
            },
        },
    ];

    const queryItems = [
        {
            formItemApis: {
                label: '身份证号',
                help: null,
                name: 'idNo',
            },
            item: <Input style={{ width: 200 }} allowClear />,
        },
        {
            formItemApis: {
                label: '姓名',
                help: null,
                name: 'name',
            },
            item: <Input style={{ width: 150 }} allowClear />,
        },
        {
            formItemApis: {
                label: '入住区域',
                help: null,
                name: 'value',
            },
            item: (
                <Select style={{ width: 150 }} placeholder="请选择" allowClear>
                    {nursingAreas.map(({ value, text }) => {
                        return (
                            <Option key={value} value={value}>
                                {text}
                            </Option>
                        );
                    })}
                </Select>
            ),
        },
        {
            formItemApis: {
                label: '入住状态',
                help: null,
                name: 'status',
            },
            item: (
                <Select style={{ width: 150 }} placeholder="请选择" allowClear>
                    {checkIn.map(({ value, text }) => {
                        return (
                            <Option key={value} value={value}>
                                {text}
                            </Option>
                        );
                    })}
                </Select>
            ),
        },
    ];

    const editModalShow = rowData => {
        const { status, name = '', nursingArea, id, createAt, idNo, identityType } = rowData;
        setid(id);
        seteditVisible(true);
        const currentNursingArea = nursingArea;
        const currentIdentityType = identityType;
        const updateAtStr = moment(createAt).format('YYYY-MM-DD HH:mm:ss');
        const updateAt = moment(updateAtStr, 'YYYY-MM-DD HH:mm:ss');
        setTimeout(() => {
            xFormRef.current.form?.setFieldsValue({
                id,
                name,
                status,
                nursingArea,
                currentNursingArea,
                updateAt,
                idNo,
                currentIdentityType,
            });
        }, 0);
    };

    const fastCheckIn = () => {
        setTimeout(() => {
            xFastFormRef.current.form?.setFieldsValue({
                name: '',
                idNo: '',
                nursingArea: '',
            });
        }, 0);
        seteditFastLoading(false);
        seteditFastVisible(true);
    };

    const downloadRecord = () => {
        const queryValue = xTableRef.current.queryForm?.getFieldsValue();
        queryValue.status = true;
        getDownloadCheckApi(queryValue).then(res => {
            if (res.success) {
                const filename = `入住记录${moment().valueOf()}.xls`;
                downFile(res.file, filename);
            }
        });
    };
    const actionBtns = [
        { text: '快速入住', onClick: fastCheckIn },
        { text: '导出记录', onClick: downloadRecord },
    ];

    // 确认修改
    const editOk = () => {
        xFormRef.current.form?.submit();
    };

    const editFastOk = () => {
        xFastFormRef.current.form?.submit();
    };

    const onCancel = () => {
        xFormRef.current.form?.setFieldsValue({
            applyCheckIn: 0,
            remaining: 0,
            waitForApprove: 0,
            total: 0,
            reserved: 0,
        });
        seteditVisible(false);
    };

    // 执行床位变更
    const onFinish = values => {
        seteditLoading(true);
        updateCheckInRecord({ ...values, id }).then(res => {
            if (res.success) {
                notification.success({
                    message: '变更成功。',
                });
                seteditVisible(false);
                xTableRef.current.refreshTable && xTableRef.current.refreshTable();
            }
            seteditLoading(false);
        });
    };

    const onFinishFast = values => {
        seteditFastLoading(true);
        fastCheckInApi(values).then(res => {
            if (res.success) {
                notification.success({ message: '入住成功' });
                seteditFastVisible(false);
                xTableRef.current.refreshTable && xTableRef.current.refreshTable();
            }
            seteditFastLoading(false);
        });
    };

    const onCancelFast = () => {
        setTimeout(() => {
            xFastFormRef.current.form?.setFieldsValue({
                name: '',
                idNo: '',
                nursingArea: '',
            });
        }, 0);
        seteditFastLoading(false);
        seteditFastVisible(false);
    };

    const formItems = [
        {
            formItemApis: {
                label: '姓名',
                help: null,
                name: 'name',
            },
            item: <Input allowClear disabled="true" />,
        },
        {
            formItemApis: {
                label: '身份证',
                help: null,
                name: 'idNo',
            },
            item: <Input allowClear disabled="true" />,
        },
        {
            formItemApis: {
                label: '是否在住',
                name: 'status',
                valuePropName: 'checked',
                rules: [{ required: true }],
            },
            item: <Switch checkedChildren="在住" unCheckedChildren="已出院" />,
        },
        {
            formItemApis: {
                label: <span className="requiredStar">入住区</span>,
                name: 'currentNursingArea',
            },
            item: (
                <Select disabled={true}>
                    {nursingAreas.map(({ value, text }) => {
                        return (
                            <Option key={value} value={value}>
                                {text}
                            </Option>
                        );
                    })}
                </Select>
            ),
        },
        {
            formItemApis: {
                label: <span className="requiredStar">护理区</span>,
                name: 'nursingArea',
                rules: [{ required: true }],
            },
            item: (
                <Select>
                    {nursingAreas.map(({ value, text }) => {
                        return (
                            <Option key={value} value={value}>
                                {text}
                            </Option>
                        );
                    })}
                </Select>
            ),
        },
        {
            formItemApis: {
                label: <span className="requiredStar">身份类型</span>,
                name: 'currentIdentityType',
                rules: [{ required: true }],
            },
            item: (
                <Select>
                    {identityType.map(({ value, text }) => {
                        return (
                            <Option key={value} value={value}>
                                {text}
                            </Option>
                        );
                    })}
                </Select>
            ),
        },
        {
            formItemApis: {
                label: <span className="requiredStar">入住时间</span>,
                name: 'updateAt',
                rules: [{ required: true }],
            },
            item: <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" />,
        },
    ];

    const formFastItems = [
        {
            formItemApis: {
                label: '姓名',
                help: null,
                name: 'name',
                rules: [{ required: true, message: '姓名不能为空' }],
            },
            item: <Input style={{ width: 150 }} allowClear />,
        },
        {
            formItemApis: {
                label: '身份证号',
                help: null,
                name: 'idNo',
                rules: [{ required: true, message: '身份证号码不能为空' }],
            },
            item: <Input placeholder="请输入入住人员身份证号码" />,
        },
        {
            formItemApis: {
                label: '入住区域',
                help: null,
                name: 'nursingArea',
                rules: [{ required: true, message: '入住区域不能为空' }],
            },
            item: (
                <Radio.Group>
                    <Space direction="vertical">
                        <Radio value="TAKE_CARE_SELF">自理区</Radio>
                        <Radio value="SEMI_CARE">半护理</Radio>
                        <Radio value="FULL_CARE">全护理区</Radio>
                    </Space>
                </Radio.Group>
            ),
        },
        {
            formItemApis: {
                label: <span className="requiredStar">身份类型</span>,
                name: 'identityType',
                rules: [{ required: true }],
            },
            item: (
                <Select>
                    {identityType.map(({ value, text }) => {
                        return (
                            <Option key={value} value={value}>
                                {text}
                            </Option>
                        );
                    })}
                </Select>
            ),
        },
    ];

    return (
        <div>
            <XTable
                columns={columns}
                queryItems={queryItems}
                actionBtns={actionBtns}
                api={getCheckInRecordListApi}
                rowKey="id"
                ref={xTableRef}
            />
            <Modal
                title="入住变更"
                centered
                wrapClassName="modalBox"
                visible={editVisible}
                onOk={editOk}
                okButtonProps={{ loading: editLoading }}
                onCancel={onCancel}>
                <XForm
                    formApis={{
                        ...formTailLayout,
                        name: 'editBad',
                        onFinish: onFinish,
                    }}
                    formItems={formItems}
                    ref={xFormRef}
                />
            </Modal>
            <Modal
                title="快速入住"
                centered
                wrapClassName="modalBox"
                visible={editFastVisible}
                onOk={editFastOk}
                okButtonProps={{ loading: editFastLoading }}
                onCancel={onCancelFast}>
                <XForm
                    formApis={{
                        ...formTailLayout,
                        name: 'editBad',
                        onFinish: onFinishFast,
                    }}
                    formItems={formFastItems}
                    ref={xFastFormRef}
                />
            </Modal>
        </div>
    );
};
export default CheckInRecord;
